import { memo, type ReactNode } from 'react';

export type AssetVersionInfoProps = {
  meta: ReactNode;
  title: ReactNode;
  titleElement?: 'h3' | 'span';
};

export const AssetVersionInfo = memo(({ meta, title, titleElement = 'h3' }: AssetVersionInfoProps) => {
  const TitleElement = titleElement;

  return (
    <div className="flex grow flex-col gap-1" data-testid="ASSET_VERSION_INFO">
      <TitleElement
        className="truncate font-medium ads:text-primary text-12 text-gray-12"
        data-testid="ASSET_VERSION_INFO_TITLE"
      >
        {title}
      </TitleElement>
      <div className="relative truncate ads:text-metadata text-12 text-gray-10" data-testid="ASSET_VERSION_INFO_META">
        {meta}
      </div>
    </div>
  );
});

AssetVersionInfo.displayName = 'AssetVersionInfo';
